module.exports = __webpack_public_path__ + "static/media/calme1.05bb9621.jpg";